import React, { useEffect } from 'react';

import { IconButton } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';

import { CloseIcon } from 'assets/icons';

import styles from './BlurPopup.module.scss';

interface BlurPopupProps extends DialogProps {
  blurDeep: number;
  onClose: () => void;
  isCloseButtonDisplayed?: boolean;
}

const BlurPopup = ({ blurDeep, open, children, onClose, isCloseButtonDisplayed, ...restProps }: BlurPopupProps) => {
  useEffect(() => {
    const rootElement = document.getElementById('main');

    if (!rootElement || !open) {
      return;
    }

    rootElement.style.filter = `blur(${blurDeep}px)`;

    return () => {
      rootElement.style.filter = '';
    };
  }, [open]);

  const body = (
    <div>
      <div className={styles.header}>
        {isCloseButtonDisplayed && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </div>
      {children}
    </div>
  );

  return (
    <Dialog
      open={open}
      classes={{
        paper: styles.paper,
      }}
      {...restProps}
    >
      {body}
    </Dialog>
  );
};

export default BlurPopup;
